export default __webpack_public_path__ + "static/instantChatBg2-cc0ccdcece470b84b7ae306d4219bc5c.png";